module.exports = __webpack_public_path__ + "static/media/cooperation.c8345ee5.svg";